<template>
  <DialogTemplateToolkit
    class-name="delete-additional-field"
    :data-qa="'delete-additional-field-dialog'"
    :dialog="opened"
    :disabled="loading"
    first_btn="Purchasing.Remove"
    :loading="loading"
    second_btn
    :title="$t('AdditionalFields.DeleteField')"
    width="600px"
    @apply="$emit('deleteField')"
    @close="$emit('close')">
    <template #backBtn>
      <sButton
        v-if="back_step"
        class="bold h7-text px-2"
        data-qa="back-btn"
        icon="long-arrow"
        icon-class="s-svg-icon-rotate-90"
        small
        type="text"
        @click="$emit( 'back')">
        {{ $t('Common.Back') }}
      </sButton>
    </template>
    <template #card-text>
      <div class="py-2">
        <div class="delete-additional-field__subtitle h5-headline">
          {{ $t('AdditionalFields.WantDeleteAdditionalField') }}
        </div>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>

<script>
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

export default {
  name: 'deleteAdditionalField',
  props: {
    back_step: {
      type: Boolean,
    },
    opened: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
  },
  components: {
    DialogTemplateToolkit
  }
}
</script>
